import { useTranslation } from "react-i18next"

import type { ThreadFailureRecoveryActions } from "../utils/agent-presence-utils"

import { ArrowRight, RefreshCw } from "@/components/icons"
import { Button } from "@/components/ui/button"

interface AgentFailureRecoveryProps {
  actions: ThreadFailureRecoveryActions | null
  onRetry: () => void
  onContinue: () => void
}

/**
 * Retry / Continue for a failed turn whose error card sits in the thread. The in-thread
 * card has no handlers, so these replace the suppressed session-level card's actions.
 */
export function AgentFailureRecovery({ actions, onRetry, onContinue }: AgentFailureRecoveryProps) {
  const { t } = useTranslation()
  if (!actions) return null
  return (
    <div className="flex flex-col gap-2 sm:ml-11 sm:flex-row sm:flex-wrap">
      {actions.retry ? (
        <Button
          className="w-full gap-1.5 text-xs sm:w-auto"
          size="sm"
          variant="secondary"
          onClick={onRetry}
        >
          <RefreshCw aria-hidden="true" className="size-3.5" />
          {t("answer.retry")}
        </Button>
      ) : null}
      {actions.continue ? (
        <Button
          className="w-full gap-1.5 text-xs sm:w-auto"
          size="sm"
          variant="ghost"
          onClick={onContinue}
        >
          {t("answer.continue")}
          <ArrowRight aria-hidden="true" className="size-3.5" />
        </Button>
      ) : null}
    </div>
  )
}
